import type { HTMLAttributes } from 'react';
import { MButtonProps } from '../MButton/MButton.types';
import { MListTextIconProps } from '../MListTextIcon/MListTextIcon.types';

/**
 * Content variant to render. Values match the exact AEM author-dialog strings
 * so the raw model deserializes directly without a normalization layer.
 */
export enum MContentSwapType {
  Button = 'Button',
  ListTextIcon = 'List Text Icon',
}

/** String-or-boolean truthy flag mirroring the AEM `cta`/`secondaryCta` pattern. */
export type MContentSwapFlag = 'true' | 'false' | boolean;

/** Cross-axis alignment for the swap items. Stacked column on small viewports, row on desktop. */
export enum MContentSwapAlignment {
  Left = 'Left',
  Centered = 'Centered',
}

export interface MContentSwapProps extends HTMLAttributes<HTMLDivElement> {
  /**
   * Active variant. Defaults to `MContentSwapType.Button`. Unknown or missing
   * values resolve to `Button`. Only the active variant is rendered; inactive
   * variant data is ignored even when supplied.
   */
  type?: MContentSwapType | string;

  /** Item alignment. `Left` (default) or `Centered`. Controls cross-axis alignment when stacked. */
  alignment?: MContentSwapAlignment;

  /** First button (rendered when `type === Button`). */
  mButton?: MButtonProps;
  /** Second button (rendered when `type === Button` and `button2` is truthy). */
  mButton2?: MButtonProps;
  /** Gates the second button. Truthy string `"true"` or boolean `true`. */
  button2?: MContentSwapFlag;

  /** First list-text-icon (rendered when `type === List Text Icon`). */
  mListTextIcon?: MListTextIconProps;
  /** Second list-text-icon (rendered when `type === List Text Icon` and `listItem2` is truthy). */
  mListTextIcon2?: MListTextIconProps;
  /** Gates the second list-text-icon. Truthy string `"true"` or boolean `true`. */
  listItem2?: MContentSwapFlag;
}
